import React, { Component, RefObject, createRef, KeyboardEvent } from 'react';
import AutoresizableInput from './autoresizableInput';
import StringMapInput from './stringMapInput';

interface IProps {
  value: Record<string, string>;
  name: string;
  onChange: (name: string, value: Record<string, string>) => void;
  disabled: boolean;
}

interface IState {
  autoFocus: boolean;
}

class StringMap extends Component<IProps, IState> {
  state: IState = { autoFocus: false };

  autoResizableInputKey: RefObject<AutoresizableInput> = createRef();

  autoResizableInputValue: RefObject<AutoresizableInput> = createRef();

  add = () => {
    const { value, name, onChange } = this.props;
    const key = this.autoResizableInputKey.current?.value as string;
    const val = this.autoResizableInputValue.current?.value as string;
    const v = { ...value, [key]: val };

    if (key !== '' && val !== '') {
      onChange(name, v);
      this.setState({ autoFocus: true });
    }
  };

  delete = (key: string) => {
    const { value, name, onChange } = this.props;
    const v = { ...value };

    delete v[key];

    onChange(name, v);
  };

  update = (key: string, newValue: string) => {
    const { value, name, onChange } = this.props;
    const v = { ...value };

    v[key] = newValue;

    onChange(name, v);
  };

  replace = (prevKey: string, key: string, newValue: string) => {
    const { value, name, onChange } = this.props;
    const v = { ...value };

    delete v[prevKey];
    v[key] = newValue;

    onChange(name, v);
  };

  keyHandler = (e: KeyboardEvent<HTMLInputElement>, i?: number) => {
    if (e.keyCode === 13) {
      if (i == null) {
        this.add();
      }
    }
  };

  render() {
    const { value } = this.props;
    const { autoFocus } = this.state;
    const keys = Object.keys(value);
    const values = Object.values(value);

    return (
      <React.Fragment>
        {keys.map((m, i) => {
          const key = keys[i];
          const val = values[i];

          return (
            <StringMapInput
              key={key}
              defaultValue={{ key, val }}
              replace={this.replace}
              update={this.update}
              remove={this.delete}
            />
          );
        })}
        <span key={keys.length}>
          <AutoresizableInput
            ref={this.autoResizableInputKey}
            type="text"
            defaultValue=""
            autoFocus={autoFocus}
            onBlur={this.add}
            onKeyDown={this.keyHandler}
          />
          <AutoresizableInput
            ref={this.autoResizableInputValue}
            type="text"
            defaultValue=""
            onBlur={this.add}
            onKeyDown={this.keyHandler}
          />
        </span>
      </React.Fragment>
    );
  }
}

export default StringMap;
